import { render, staticRenderFns } from "./ContextProductSelector.vue?vue&type=template&id=5627bb41&"
import script from "./ContextProductSelector.vue?vue&type=script&lang=js&"
export * from "./ContextProductSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports